const {
  REACT_APP_API_URL,
  REACT_APP_APP_URL,
  REACT_APP_CDN_URL,
  REACT_APP_IMAGES_BUCKET_URL,
  REACT_APP_STRIPE_PK,
  REACT_APP_STRIPE_PK_TEST,
  REACT_APP_ROOT_DOMAIN,
  REACT_APP_STORE_URL,
  REACT_APP_MIXPANEL_TOKEN,
  REACT_APP_MIXPANEL_API_HOST,
  REACT_APP_POSTHOG_KEY,
  REACT_APP_POSTHOG_HOST,
  REACT_APP_SANITY_API_VERSION,
  REACT_APP_SANITY_PROJECT_ID,
  REACT_APP_SANITY_DATASET,
  REACT_APP_SANITY_USE_CDN,
  REACT_APP_SANITY_DEV_TOKEN,
  REACT_APP_ASSETS_CDN_URL,
  VERCEL_ENV,
  VERCEL_URL,
  VERCEL_BRANCH_URL,
  VERCEL_RELATED_PROJECTS,
  REACT_APP_VERCEL_PROTECTION_BYPASS,
} = process.env;

export const apiUrl = REACT_APP_API_URL;
export const mailTemplatesUrl = REACT_APP_API_URL.replace('/api/v1', '/mail-templates');

function getUrl(url) {
  if (url.startsWith('https://') || url.startsWith('http://')) {
    return url;
  }

  return `https://${url}`;
}

let appUrl;
if (VERCEL_ENV === 'production') {
  appUrl = getUrl(REACT_APP_APP_URL);
} else {
  appUrl = getUrl(VERCEL_BRANCH_URL || REACT_APP_APP_URL);
}
export { appUrl };

export const cdnUrl = REACT_APP_CDN_URL;
export const imagesBucketUrl = REACT_APP_IMAGES_BUCKET_URL;
export const stripePublicKey = REACT_APP_STRIPE_PK;
export const stripePublicKeyTest = REACT_APP_STRIPE_PK_TEST;

export const mixpanelToken = REACT_APP_MIXPANEL_TOKEN;
export const mixpanelApiHost = REACT_APP_MIXPANEL_API_HOST;

export const posthogKey = REACT_APP_POSTHOG_KEY;
export const posthogHost = REACT_APP_POSTHOG_HOST;

export const isProduction = VERCEL_ENV === 'production';
export const isPreview = VERCEL_ENV === 'preview';

export const isStaging = VERCEL_BRANCH_URL?.includes('staging');
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isTesting = process.env.NODE_ENV === 'test';
export const rootDomain = REACT_APP_ROOT_DOMAIN;

// Set only by scripts/write-instance-env-files.sh. Instance stacks have no
// subdomain routing, so previews have to address the store by port and path.
export const storeUrl = REACT_APP_STORE_URL;
export const vercelRelatedProjects = VERCEL_RELATED_PROJECTS;
export const vercelProtectionBypass = REACT_APP_VERCEL_PROTECTION_BYPASS;

export const apiVersion = REACT_APP_SANITY_API_VERSION;
export const dataset = REACT_APP_SANITY_DATASET;
export const projectId = REACT_APP_SANITY_PROJECT_ID;
export const useCdn = REACT_APP_SANITY_USE_CDN;
export const sanityDevToken = REACT_APP_SANITY_DEV_TOKEN;

export const vercelDeploymentId = VERCEL_URL?.match(/checkoutpage-([^-]+)-checkoutpage/)?.[1];

export const stripePlatformAccountId = 'acct_1BlJk4KoWs5tH5ri';

export const overlayUrl = (() => {
  if (isProduction) {
    return `${REACT_APP_ASSETS_CDN_URL}/overlay.js`;
  }

  if (isDevelopment) {
    return `https://assets.${REACT_APP_ROOT_DOMAIN}/overlay.js`;
  }

  if (vercelDeploymentId) {
    return `${REACT_APP_ASSETS_CDN_URL}/staging/overlay-${vercelDeploymentId}.js`;
  }

  if (isPreview) {
    return `${REACT_APP_ASSETS_CDN_URL}/staging/overlay.js`;
  }

  return `${REACT_APP_ASSETS_CDN_URL}/overlay.js`;
})();

// @TODO scanner ticket we want to be able share vercel deployment urls between projects
export const eventsAppUrl = (() => {
  if (isProduction) {
    return `https://events.${rootDomain}`;
  }

  if (isPreview) {
    return 'https://events.checkoutfront.com';
  }

  return 'https://events.checkoutpage.dev';
})();
